module.exports = __webpack_public_path__ + "static/media/dummy_relationships.95e78314.png";